import { ModelBase } from '../../core/model/model-base';
import { DirectDebitStatus } from './const/enums';

export class Creditor extends ModelBase {
  constructor() {
    super();
    this.contactIdentification = '';
    this.email = '';
    this.phone = '';
  }

  contactIdentification: string;

  get displayName(): string {
    return this.name;
  }

  number: number;
  name: string;
  email: string;
  phone: string;

  toAutocompleteValue(consumerType?: 'list' | 'field', culture?: string): string {
    if (consumerType) {
      switch (consumerType) {
        case 'field':
          return this.toString();
        case 'list':
          return `${this.number} ${this.name} ${this.contactIdentification}`;
      }
    }
  }

  toJSON() {
    return this.id;
  }

  toString() {
    return `${this.number} ${this.name}`;
  }
}
